import { BoletagemProduto } from "../boletagem-produto";

export enum BoletagemProdutoAnexoTipo {
  "Nota Fiscal" = "NF"
}

export interface BoletagemProdutoAnexo {
  readonly id?: number | null;
  readonly produto?: BoletagemProduto | null;
  readonly tipo?: BoletagemProdutoAnexoTipo | null;
  readonly storagePath?: string | null;
  readonly originalFilename?: string | null;
}
